import { render, staticRenderFns } from "./BuildInfo.vue?vue&type=template&id=5350f744&scoped=true&"
import script from "./BuildInfo.vue?vue&type=script&lang=js&"
export * from "./BuildInfo.vue?vue&type=script&lang=js&"
import style0 from "./BuildInfo.vue?vue&type=style&index=0&id=5350f744&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5350f744",
  null
  
)

export default component.exports